<template>
    <Card :title="$t('labels.product_type')">
        <div class="card-body">
            <CategoryFieldsetGroup v-model:category="category" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="create">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import CategoryFieldsetGroup from './fieldsets/CategoryFieldsetGroup.vue';

import { httpClient } from '../../../../services/HttpClient.ts';

export default {
    name: 'CreateCategoryPage',
    components: {
        Card, AppButton, CategoryFieldsetGroup
    },
    data() {
        return {
            category: {
                name: '',
                markup: 0
            }
        }
    },
    methods: {
        async create() {
            let request = {};

            if (this.category.name) {
                request.name = this.category.name
            }

            if (this.category.markup) {
                request.markup = this.category.markup
            }

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/pim/types`, request).then((response) => {
                this.$router.push({ name: 'InternalProductTypesIndexPage' })
            })
        }
    }
}
</script>